import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './Provider';
import Spinner from './common/Spinner';
import { useTranslation } from 'react-i18next';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();
  const { t } = useTranslation('common');

  if (loading) {
    return (
      <div className="protected-route-loading">
        <Spinner 
          size="large" 
          customText={t('auth.checking_authentication')}
        />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
